import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom'; //https://stackoverflow.com/questions/42173786/react-router-pass-data-when-navigating-programmatically
//<Link to={{ pathname: '/post', state: { id: 1, name: 'sabaoon', shirt: 'green' } }} >Learn More</Link>
import './UserScreen.css';
import Nav from '../../components/Nav/Nav'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentUser } from '../../features/currentUser'
import { Oval, MagnifyingGlass } from 'react-loader-spinner'
import { getGroupsByUserId, getPremiumMessagesOfUser, getUserProfileInfoWithId, getUsersLastSixPosts } from '../../services/f';
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry" //https://youtu.be/RDxnu8Xt5Rk + https://cedricdelpoux.github.io/react-responsive-masonry/
import { BsBrowserSafari, BsPlusCircle, BsInfoCircle, BsInstagram, BsFillCheckCircleFill, BsTiktok, BsTwitter, BsYoutube } from 'react-icons/bs'  //https://react-icons.github.io/react-icons
import { MdErrorOutline } from 'react-icons/md'
import { TbCircleLetterP } from 'react-icons/tb'
import { PiUserCircleLight } from 'react-icons/pi'
import Footer from '../../components/Footer';
import { auth } from '../../firebase';
import VerifyEmailComponent from '../../components/rememberverifyemail';
import { Helmet } from 'react-helmet';
import { HiOutlineLockClosed } from "react-icons/hi";
import { IoIosArrowDropright } from 'react-icons/io'

function UserScreen() {
  // http://localhost:3000/user?id=sdffsdf
  // http://localhost:3000/user?id=MFbwMsG0SkVnOYTUMZRKeshqBmA2
  const [searchParams, setSearchParams] = useSearchParams();
  let currentUser = useSelector(getCurrentUser).currentUser?.currentUser// ALSO WENNS n user gibt dann wird anderes screen angezeigt
  const navigate = useNavigate()

  const [userProfile, setuserProfile] = useState(null);
  const [showpremiumposts, setshowpremiumposts] = useState(0);
  const [showmoreinfo, setshowmoreinfo] = useState(false);

  const [userPosts, setuserPosts] = useState(["null"]);
  const [groups, setgroups] = useState([]);

  const [pmtype, setpmtype] = useState();
  const [premiummessages, setpremiummessages] = useState([]);

  useEffect(() => {
    // check if user or psot available then query for them and show them
    // get specific   searchParams.get("code")

    let userid = searchParams.get("id")
    if (userid === null || userid === undefined || userid === "") {
      setuserProfile("usernotexists")
    } else {
      getUserProfileInfoWithId(userid).then((res) => {
        //console.log("getUserProfileInfoWithId result", res)
        setuserProfile(res)
        getUsersLastSixPosts(res.uid, currentUser).then((posts) => {
          //console.log("these are getUsersLastSixPosts", posts)
          setuserPosts(posts)
        })
      })
    }

    let fasttrack = searchParams.get("t")
    if (fasttrack === null || fasttrack === undefined || fasttrack === "") {
      return
    } else {
      setshowpremiumposts(2)
    }
  }, []);

  useEffect(() => {
    if (showpremiumposts !== 3 || !userProfile || userProfile === "usernotexists") {
      return;
    }
    console.log("usergroupProfile", userProfile.uid, currentUser)
    getGroupsByUserId(userProfile.uid, currentUser).then((gottengroups) => {
      if (gottengroups === "empty") {
        setgroups([]);
        return;
      }
      setgroups(gottengroups);
    });
  }, [showpremiumposts, userProfile]);

  useEffect(() => {
    if (!userProfile || userProfile === "usernotexists" || showpremiumposts !== 2) return;
    if (pmtype === 0) {
      getPremiumMessagesOfUser(userProfile.uid, "image").then(setpremiummessages);
    } else if (pmtype === 1) {
      getPremiumMessagesOfUser(userProfile.uid, "video").then(setpremiummessages);
    } else if (pmtype === 2) {
      getPremiumMessagesOfUser(userProfile.uid, "pdf").then(setpremiummessages);
    }
  }, [pmtype, showpremiumposts, userProfile]);

  useEffect(() => {
    // console.log("first", premiummessages)
  }, [premiummessages]);

  const formatNumber = n => {
    if (n < 1e3) return n;
    if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
    if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(2) + "M";
    if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(3) + "B";
    if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
  };
  let v = "Checkout what content " + userProfile?.displayName + " posted." + "Sell and market digital content in seconds . Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute."
  let titletext = "Premsi - User: " + userProfile?.displayName

  const hasBanner = userProfile && userProfile?.bannerBgImage !== "" && userProfile?.bannerBgImage != null && userProfile?.bannerBgImage !== undefined
  const hasBioOrSocials = userProfile && !(userProfile?.profiles[0] === "" && userProfile?.profiles[1] === "" && userProfile?.profiles[2] === "" && userProfile?.profiles[3] === "" && userProfile?.profiles[4] === "" && userProfile?.creatorinfo === "")
  const bioMarginModifier = userProfile?.creatorinfo === "" ? "user-profile__bio--socials-only" : ""

  return (
    <div className="user-profile userscreen">
      <Helmet>

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Premsi | User - Sell digital content in minutes❤️" />
        <meta property="og:description" content="Premsi | Sell and market digital content in seconds. Download the Premsi App for more features. Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute." />
        <meta property="og:url" content="https://premsi.com/user" />
        <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/premsicom-accb2.appspot.com/o/P1-min.png?alt=media&token=1fbb167c-ed04-444c-b45c-dc411cdbb16f" />
        <meta property="og:site_name" content="Premsi - sell digital content" />
        <link rel="canonical" href="https://premsi.com/user" />

        <title>{titletext}</title>
        <meta name="description" content={String(v)} />
      </Helmet>
      <Nav />
      {auth.currentUser === null || auth.currentUser === undefined || auth.currentUser.emailVerified === true ? null : <VerifyEmailComponent />}

      <div className="user-profile__body body">
        <div className="user-profile__card userscreen__body">

          {userProfile === null ? (
            <div className="user-profile__loading">
              <div className="user-profile__loading-spinner">
                <Oval
                  height={40}
                  width={40}
                  color="#009FFD"
                  wrapperClass=""
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="white"
                  strokeWidth={5}
                  strokeWidthSecondary={5}
                />
              </div>
              <p className="user-profile__loading-text">Loading user...</p>
              <p className="user-profile__loading-hint">If this takes too long please refresh this window.</p>
            </div>
          ) : userProfile === "usernotexists" ? (
            <div className="user-profile__not-found">
              <div className="user-profile__not-found-icon">
                <MagnifyingGlass
                  height={40}
                  width={40}
                  color="#009FFD"
                  wrapperClass=""
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="white"
                  strokeWidth={5}
                  strokeWidthSecondary={5}
                />
              </div>
              <p className="user-profile__not-found-title">No user...</p>
              <p className="user-profile__not-found-desc">It seems that you have a wrong link and this user doesn't exist</p>
              <p className="user-profile__not-found-desc">Please recheck your link.</p>
              <div className="user-profile__not-found-actions">
                <button type="button" onClick={() => navigate("/alternativehomepage")} className="user-profile__btn user-profile__btn--secondary">Explore more</button>
              </div>
            </div>
          ) : (
                <>
                  <div className="user-profile__banner topbannerprofile">
                    {hasBanner && (
                      <img loading="lazy" className="user-profile__banner-img avatar_profilebanner" src={userProfile?.bannerBgImage} alt="Premsi user pic" />
                    )}

                    <div className={`user-profile__avatar avatar_nopic_profile_div ${hasBanner ? "user-profile__avatar--with-banner" : "user-profile__avatar--no-banner"} ${userProfile?.photoUrl === "" || userProfile?.photoUrl == null || userProfile === undefined ? "user-profile__avatar--fallback" : ""}`}>
                      {userProfile?.photoUrl === "" || userProfile?.photoUrl == null || userProfile === undefined ? (
                        <PiUserCircleLight className="user-profile__avatar-fallback avatar_nopic_profile" size={50} color="#fff" alt="no profile picture" />
                      ) : (
                        <img loading="lazy" className="user-profile__avatar-img avatar_profile" src={userProfile?.photoUrl} alt="Premsi user pic" />
                      )}
                    </div>
                  </div>

                  <div className="user-profile__info userscreen__info">
                    <div className="user-profile__details userscreen__details">
                      <div className="user-profile__identity userscreen__topuserinfo">
                        <div className="user-profile__username username">
                          @{userProfile?.displayName}
                          {userProfile?.verified && (
                            <span className="user-profile__verified-badge" aria-hidden>
                              <BsFillCheckCircleFill size={18} color="blue" alt="verified account" />
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="user-profile__stats">
                        <div className="user-profile__stat stat-item">
                          <p className="user-profile__stat-number stat-number">{formatNumber(userProfile?.followers)}</p>
                          <p className="user-profile__stat-label stat-label">Followers</p>
                        </div>
                        <div className="user-profile__stat stat-item">
                          <p className="user-profile__stat-number stat-number">{formatNumber(userProfile?.followingamount)}</p>
                          <p className="user-profile__stat-label stat-label">Following</p>
                        </div>
                        <div className="user-profile__stat stat-item">
                          <p className="user-profile__stat-number stat-number">{formatNumber(userProfile?.amountpremiumposts)}</p>
                          <p className="user-profile__stat-label stat-label">Premium Posts</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {hasBioOrSocials && (
                    <div className={`user-profile__bio userbioinfouserscreen ${bioMarginModifier}`}>
                      {userProfile?.creatorinfo !== "" && <p>{userProfile?.creatorinfo}</p>}
                      {!(userProfile?.profiles[0] === "" && userProfile?.profiles[1] === "" && userProfile?.profiles[2] === "" && userProfile?.profiles[3] === "" && userProfile?.profiles[4] === "") && (
                        <div className="user-profile__socials userProfilesocials">
                          <div className="user-profile__socials-inner inneruserProfilesocials">
                            {userProfile?.profiles.map((link, i) =>
                              link === "" ? null : (
                                i === 0 ? <a key={i} className="user-profile__social-link socialicon" href={link}><BsInstagram size={23} color="white" /></a> :
                                i === 1 ? <a key={i} className="user-profile__social-link socialicon" href={link}><BsYoutube size={23} color="white" /></a> :
                                i === 2 ? <a key={i} className="user-profile__social-link socialicon" href={link}><BsTwitter size={23} color="white" /></a> :
                                i === 3 ? <a key={i} className="user-profile__social-link socialicon" href={link}><BsTiktok size={23} color="white" /></a> :
                                <a key={i} className="user-profile__social-link socialicon" href={link}><BsBrowserSafari size={23} color="white" /></a>
                              )
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  <div className="user-profile__cta">
                    <h2 className="user-profile__cta-text cta-button">To chat, follow, like, comment etc. with {userProfile?.displayName} please <a href="/app" className="user-profile__cta-link">download</a> our App.</h2>
                  </div>

                  <div className="user-profile__content userPosts">
                    <div className="user-profile__tabs nav-tabs">
                      <button type="button" onClick={() => setshowpremiumposts(0)} className={showpremiumposts === 0 ? "user-profile__tab nav-tab active" : "user-profile__tab nav-tab"}>Normal Posts</button>
                      <button type="button" onClick={() => setshowpremiumposts(1)} className={showpremiumposts === 1 ? "user-profile__tab nav-tab active" : "user-profile__tab nav-tab"}>Premium Posts</button>
                      <button type="button" onClick={() => setshowpremiumposts(2)} className={showpremiumposts === 2 ? "user-profile__tab nav-tab active" : "user-profile__tab nav-tab"}>Premium Messages</button>
                      <button type="button" onClick={() => setshowpremiumposts(3)} className={showpremiumposts === 3 ? "user-profile__tab nav-tab active" : "user-profile__tab nav-tab"}>Groups</button>
                    </div>

                    {showpremiumposts === 2 && (
                      <div className="user-profile__pm-filter pm-filter">
                        <button type="button" onClick={() => setpmtype(0)} className={pmtype === 0 ? "user-profile__pm-filter-btn pm-filter__btn pm-filter__btn--active" : "user-profile__pm-filter-btn pm-filter__btn"}>Pictures</button>
                        <button type="button" onClick={() => setpmtype(1)} className={pmtype === 1 ? "user-profile__pm-filter-btn pm-filter__btn pm-filter__btn--active" : "user-profile__pm-filter-btn pm-filter__btn"}>Videos</button>
                        <button type="button" onClick={() => setpmtype(2)} className={pmtype === 2 ? "user-profile__pm-filter-btn pm-filter__btn pm-filter__btn--active" : "user-profile__pm-filter-btn pm-filter__btn"}>PDFs</button>
                      </div>
                    )}

                    {showpremiumposts === 1
                      ? (currentUser?.premium === true && currentUser?.premiumend > (new Date().getTime() / 1000)
                        ? (
                          <div className="user-profile__gate user-profile__gate--success premiumavailableparent">
                            <div className="user-profile__gate-message">
                              <TbCircleLetterP size={22} color="green" alt="subscribed" />
                              <p>Thank you for having subscribed to Premsi Premium.</p>
                            </div>
                            <p className="user-profile__gate-title">Now you can see all premium posts of all creators + a lot of benefits in our App!</p>
                            <div className="user-profile__gate-actions pm-section-footer">
                              <button type="button" onClick={() => navigate("/app")} className="pm-section-footer__btn">Download our App</button>
                            </div>
                          </div>
                        )
                        : (currentUser === null || currentUser === undefined ? (
                          <div className="user-profile__gate user-profile__gate--error premiumnotavailableparent">
                            <div className="user-profile__gate-message">
                              <MdErrorOutline size={22} color="red" alt="not logged in" />
                              <p>Unfortunately, you are not logged in.</p>
                            </div>
                            <p className="user-profile__gate-title">Login to be able to see the premium posts of all creators.</p>
                            <div className="user-profile__gate-actions pm-section-footer user-profile__gate-actions--row">
                              <button type="button" onClick={() => navigate("/alternativehomepage")} className="pm-section-footer__btn">All in one premium for only 3.49$</button>
                              <BsInfoCircle className="user-profile__gate-info-icon" onClick={() => setshowmoreinfo(!showmoreinfo)} size={17} color="white" aria-hidden />
                            </div>
                            {showmoreinfo && (
                              <>
                                <p className="user-profile__gate-extra">Correct! Our 3.49$ subscription is an universal subscription for all the premium posts of our creators.</p>
                                <p className="user-profile__gate-extra">There's no need anymore to individually subscribe to your favorite creator.</p>
                              </>
                            )}
                          </div>
                        ) : (
                          <div className="user-profile__gate user-profile__gate--error premiumnotavailableparent">
                            <div className="user-profile__gate-message">
                              <MdErrorOutline size={22} color="red" alt="not subscribed" />
                              <p>Unfortunately, you don't have our premium subscription.</p>
                            </div>
                            <p className="user-profile__gate-title">Get Premsi Premium for 3.49$ and see the premium posts of all creators.</p>
                            <div className="user-profile__gate-actions pm-section-footer user-profile__gate-actions--row">
                              <button type="button" onClick={() => navigate("/profile")} className="pm-section-footer__btn">Get it now for 3.49$</button>
                              <BsInfoCircle className="user-profile__gate-info-icon" onClick={() => setshowmoreinfo(!showmoreinfo)} size={17} color="white" aria-hidden />
                            </div>
                            {showmoreinfo && (
                              <>
                                <p className="user-profile__gate-extra">Correct! Our 3.49$ subscription is an universal subscription for all the premium posts of our creators.</p>
                                <p className="user-profile__gate-extra">There's no need anymore to individually subscribe to your favorite creator.</p>
                              </>
                            )}
                          </div>
                        )))
                      : showpremiumposts === 0
                        ? (userPosts[0] !== "null" && (
                          <>
                            <ResponsiveMasonry columnsCountBreakPoints={{ 150: 1, 500: 1, 700: 1, 900: 1, 1250: 1 }}>
                              <Masonry gutter="5px">
                                {userPosts?.map((post, i) => (
                                  <img
                                    loading="lazy"
                                    key={i}
                                    src={post[1].type === "image" ? post[1]?.media[0] : post[1]?.media[1]}
                                    className="user-profile__post-thumb"
                                    onError={(e) => (e.target.src = require("../../images/pblue-min.webp"))}
                                    onClick={() => navigate("/post?id=" + post[0])}
                                    alt={"Premsi Post " + (post[1]?.description || "")}
                                  />
                                ))}
                              </Masonry>
                            </ResponsiveMasonry>
                            {userPosts?.length === 0 ? (
                              <div className="user-profile__empty">
                                <p className="user-profile__empty-text">This user doesn't have posts yet 😢</p>
                                <p className="user-profile__empty-text">Or login to see the sensitive posts</p>
                              </div>
                            ) : null}
                          </>
                        ))
                        : showpremiumposts === 2
                          ? (
                            <div className="user-profile__pm-list premiumavailableparent">
                              {premiummessages.length === 0 ? (
                                <p className="user-profile__empty-text userPosts__empty">This user doesn't have any premium messages in this category yet 😢</p>
                              ) : (
                                [...premiummessages]?.map((pm) => (
                                  <div key={pm[0]} className="group-card pm-card" onClick={() => navigate(`/pm?id=${pm[0]}`)}>
                                    <div className="group-header">
                                      <div className="group-icon">🔒</div>
                                      <div>
                                        <h2 className="group-title">{pm[1].price}$</h2>
                                        <button type="button" onClick={(e) => { e.stopPropagation(); navigate(`/pm?id=${pm[0]}`); }} className="view-button">View</button>
                                      </div>
                                    </div>
                                    {pm[1].description ? <p className="group-description">{pm[1].description}</p> : null}
                                  </div>
                                ))
                              )}
                              <div className="user-profile__section-footer pm-section-footer">
                                <p className="pm-section-footer__text">Please download our App to see and buy them + a lot of other benefits!</p>
                                <button type="button" onClick={() => navigate("/app")} className="pm-section-footer__btn">Download our App</button>
                              </div>
                            </div>
                          )
                          : (
                            <div className="user-profile__groups userPosts userPosts--groups">
                              {groups.length === 0 ? (
                                <p className="user-profile__empty-text userPosts__empty">This user doesn't have any groups yet 😢</p>
                              ) : (
                                [...groups]?.map((group) => (
                                  <div key={group[0]} className="group-card" onClick={() => navigate(`/group?id=${group[0]}`)}>
                                    <div className="group-header">
                                      <img loading="lazy" onClick={(e) => { e.stopPropagation(); navigate(`/group?id=${group[0]}`); }} className="groupimg" src={group[1].media} alt="Premsi.com paid group" />
                                      <div className="user-profile__group-info">
                                        <h2 className="group-title">{group[1].grouptitle} {group[1].price}${group[1].onetimefee ? null : "/m"}</h2>
                                        <button type="button" onClick={(e) => { e.stopPropagation(); navigate(`/group?id=${group[0]}`); }} className="view-button">View</button>
                                      </div>
                                    </div>
                                    {group[1].description ? <p className="group-description">{group[1].description}</p> : null}
                                  </div>
                                ))
                              )}
                            </div>
                          )
                    }
                  </div>

                  {showpremiumposts === 0 && (
                    <p className="user-profile__footer belowpostsinfo">You have seen {userProfile?.displayName}'s latest posts. To see more posts please <a href="/app" className="user-profile__footer-link">download</a> our App.</p>
                  )}
                  {showpremiumposts === 3 && (
                    <p className="user-profile__footer belowpostsinfo">To join {userProfile?.displayName}'s groups <a href="/app" className="user-profile__footer-link">download</a> our App.</p>
                  )}
                </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default UserScreen
